import React from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import { useAtom } from 'jotai';
import {
  shareNoteAtom,
  stepPaymentTicketAtom,
  goToPayAtom,
  ticketAtom,
} from 'Atoms/Ticket';
import useStyles from './styles';
import { Button } from '@material-ui/core';

const ShareNotePeople = ({ state, dispatch, id }) => {
  const history = useHistory();
  const classes = useStyles();
  const [, setShareNote] = useAtom(shareNoteAtom);
  // const [amountToPay, setAmountToPay] = useAtom(amountToPayAtom)
  const [, setStepPaymentTicket] = useAtom(stepPaymentTicketAtom);
  const [, setGoToPay] = useAtom(goToPayAtom);
  const [ticket] = useAtom(ticketAtom)

  const delayRedirect = (e, to, data) => {
    e.preventDefault();
    const sharePeopleNumber = data && Number.isInteger(data) ? data : 0;

    const selected = 'perPeople';
    const value = sharePeopleNumber;
    setShareNote({ selected, value });
    setStepPaymentTicket({ step: 'checkout' });
    setGoToPay(true);

    const tipsDisabled = ticket.tips && ticket.tips.enable === false
    const to2 = tipsDisabled && sharePeopleNumber ? `/ticket/:${id}/pay/form` : to

    setTimeout(() => history.push(to2), 700);
  };
  const handleTouchStart = () => {};

  return (
    <>
      <Link to={{}} onClick={(e) => delayRedirect(e, `/ticket/:${id}/tips`, 2)}>
        <button className={classes.button} onTouchStart={handleTouchStart()}>
          2
        </button>
      </Link>
      <Link to={{}} onClick={(e) => delayRedirect(e, `/ticket/:${id}/tips`, 3)}>
        <button className={classes.button} onTouchStart={handleTouchStart()}>
          3
        </button>
      </Link>
      <Link to={{}} onClick={(e) => delayRedirect(e, `/ticket/:${id}/tips`, 4)}>
        <button className={classes.button} onTouchStart={handleTouchStart()}>
          4
        </button>
      </Link>
      <Link
        to={{}}
        onClick={(e) =>
          delayRedirect(e, `/ticket/:${id}/share/calculator`, '+')
        }
      >
        <button className={classes.button} onTouchStart={handleTouchStart()}>
          +
        </button>
      </Link>
    </>
  );
};

ShareNotePeople.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ShareNotePeople;
